<nav class="nav">
  @for (tab of tabsLink(); track tab.index) {
    <div #tab class="tab">
      <a
        #rla="routerLinkActive"
        routerLinkActive="active"
        [routerLink]="tab.link"
        [class.active]="rla.isActive"
        [routerLinkActiveOptions]="activeOptions">
        <span [translate]="tab.i18nKey"> </span>
      </a>
    </div>
  }
  <div
    [style.left.px]="stickStart"
    [style.width.px]="stickWidth"
    class="stick"></div>
</nav>
